export const helper = () => ({});
export const qs = json => {
  if (typeof json !== 'object') return '';
  return `?${Object.keys(json).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(json[key]) || ''}`).join('&')}`;
};

export const get = (obj, path, defaultValue = undefined) => {
  const travel = regexp =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === undefined || result === obj ? defaultValue : result;
};

export const omit = (obj, arr) => {
  const newObj = Object.assign({}, obj);
  if (Array.isArray(arr)) {
    for(const k of arr) {
      delete newObj[k];
    }
  }
  if (typeof arr === 'string') {
    delete newObj[arr];
  }
  return newObj;
};

export const isEmpty = obj => [Object, Array].includes((obj || {}).constructor) && !Object.entries((obj || {})).length;
